import { BreakDownPartDTO } from '../DTOs/BreakDownPartDTO';

export class PriceBreakdown {
  id: number | undefined;
  packing: BreakDownPartDTO;
  logistics: BreakDownPartDTO;
  margin: BreakDownPartDTO;
  customs: BreakDownPartDTO;
  tax: BreakDownPartDTO;
  rebate: BreakDownPartDTO;
  rvat: BreakDownPartDTO;

  constructor(
    id: number | undefined,
    packing: BreakDownPartDTO,
    logistics: BreakDownPartDTO,
    margin: BreakDownPartDTO,
    customs: BreakDownPartDTO,
    tax: BreakDownPartDTO,
    rebate: BreakDownPartDTO,
    rvat: BreakDownPartDTO,
  ) {
    this.id = id;
    this.packing = packing;
    this.logistics = logistics;
    this.margin = margin;
    this.customs = customs;
    this.tax = tax;
    this.rebate = rebate;
    this.rvat = rvat;
  }

  public static makeZeroPriceBreakdown() {
    return new PriceBreakdown(
      0,
      { id: 0, percentage: 0, value: 0, primaryType: 'PERCENTAGE' },
      { id: 0, percentage: 0, value: 0, primaryType: 'PERCENTAGE' },
      { id: 0, percentage: 0, value: 0, primaryType: 'PERCENTAGE' },
      { id: 0, percentage: 0, value: 0, primaryType: 'PERCENTAGE' },
      { id: 0, percentage: 0, value: 0, primaryType: 'PERCENTAGE' },
      { id: 0, percentage: 0, value: 0, primaryType: 'PERCENTAGE' },
      { id: 0, percentage: 0, value: 0, primaryType: 'PERCENTAGE' },
    );
  }
}
